import {AbstractTimeSelector} from '@gongxigames/framework/integrations/pop/sessionTimer/timeSelector/TimeSelector';

export class DropDownTimeSelector extends AbstractTimeSelector<HTMLDivElement> {
    protected _selectedValue!: HTMLDivElement;
    protected _selectList!: HTMLDivElement;

    protected initView(times: number[], defaultTimeIndex: number): void {
        this.view = document.createElement('div');
        this.view.className = 'selector';

        this.createSelectedValueField(times[defaultTimeIndex]);
        this.createSelectList(times);
    }

    protected createSelectedValueField(time: number): void {
        this._selectedValue = document.createElement('div');
        this._selectedValue.className = 'selected-value';
        this.updateSelectedValue(time);
        this._selectedValue.onclick = this.toggleSelectList.bind(this);
        this.view.appendChild(this._selectedValue);
    }

    protected toggleSelectList(): void {
        this._selectList.classList.toggle('hidden');

        this.addSpecificToSelectTagBehaviour();
    }

    protected addSpecificToSelectTagBehaviour(): void {
        const isHidden = this._selectList.classList.contains('hidden');

        if (isHidden) {
            document.removeEventListener('click', this.hideSelectList, false);
        } else {
            document.addEventListener('click', this.hideSelectList, false);
        }
    }

    protected hideSelectList(e: any): void {
        // hide select list in case of clicking anywhere outside the list itself
        if (!e.target.classList.contains('selected-value')) {
            this._selectList.classList.add('hidden');
            document.removeEventListener('click', this.hideSelectList, false);
        }
    }

    protected createSelectList(times: number[]): void {
        this._selectList = document.createElement('div');
        this._selectList.className = 'select-list hidden';
        this.view.appendChild(this._selectList);

        times.forEach(this.createSelectOption.bind(this));
    }

    protected createSelectOption(time: number): void {
        const option = document.createElement('div');

        option.innerText = time + ' min';
        option.onclick = (e: any) => this.onOptionClick(e, time);

        this._selectList.appendChild(option);
    }

    protected onOptionClick(e: any, time: number): void {
        this.updateSelectedValue(time);
        this._onSelectCallback(time);

        this.toggleSelectList();
    }

    protected updateSelectedValue(time: number): void {
        this._selectedValue.innerText = time + ' min';
    }
}
